import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Footer } from '@getgo/chameleon-react';

class FooterComponent extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  render() {
    const { t } = this.context;
    return (
      <Footer
        termsUrlValue={t('footer.termsUrl')}
        privacyUrlValue={t('footer.privacyUrl')}
        termsUrlLabel={t('footer.terms')}
        privacyUrlLabel={t('footer.privacy')}
        copyrightLabel={t('footer.copyright', {
          year: new Date().getFullYear()
        })}
      />
    );
  }
}

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/Application/Footer/FooterComponent.js